import { createActions, createReducer } from 'reduxsauce'

import DetalhesReceitaDiariaService from '../../servicos/DetalhesReceitaDiariaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesReceitaDiariaInicio: [],
    buscaDetalhesReceitaDiariaSucesso: ['detalhesReceitaDiaria'],
    buscaDetalhesReceitaDiariaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesReceitaDiaria = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesReceitaDiariaInicio())
        let serv = new DetalhesReceitaDiariaService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesReceitaDiariaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesReceitaDiariaErro(error)))
    }
}

const buscaDetalhesReceitaDiariaInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesReceitaDiariaErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesReceitaDiariaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesReceitaDiaria, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_RECEITA_DIARIA_INICIO]: buscaDetalhesReceitaDiariaInicio,
    [Types.BUSCA_DETALHES_RECEITA_DIARIA_ERRO]: buscaDetalhesReceitaDiariaErro,
    [Types.BUSCA_DETALHES_RECEITA_DIARIA_SUCESSO]: buscaDetalhesReceitaDiariaSucesso,
})
